/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebnameplaceholder3Inputs */

const en_placewebnameplaceholder3 = /** @type {(inputs: Placewebnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name of the place`)
};

const de_placewebnameplaceholder3 = /** @type {(inputs: Placewebnameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Orts`)
};

/**
* | output |
* | --- |
* | "Name of the place" |
*
* @param {Placewebnameplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebnameplaceholder3 = /** @type {((inputs?: Placewebnameplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebnameplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebnameplaceholder3(inputs)
	return de_placewebnameplaceholder3(inputs)
});
export { placewebnameplaceholder3 as "placeWebNamePlaceholder" }